<template lang="pug">
  b-container.h-100
    b-row.w-100.h-100.align-items-center.justify-content-center
      b-col
        .text-center
          h3 Conectando con 
            v-icon.ml-1(name="brands/stripe", scale="5")
          .text-center
            b-spinner(size="lg", variant="primary", v-if="loading")
            p.text-danger(v-if="error") Ocurrió un error obteniendo liga de Stripe
            b-button(v-if="error", variant="soft-primary", :to="{name: 'Stripe', params:{account_id: $route.params.account_id} }") Ir a mi cuenta
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const stripeController = createNamespacedHelpers('stripe')

export default {
  data () {
    return {
      loading: true,
      error: false
    }
  },
  methods: {
    ...mapActions(['stripe/register']),
    generateStripeRegisterLink () {

      this['stripe/register']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.success) {
            window.location = res.resource
          } else {
            this.loading = false;
            this.error = true;
          }
        }
      })
    }
  },
  created () {
    this.generateStripeRegisterLink()
  }
}
</script>

<style lang="scss">

</style>